/**
 * 接口加解密方法
 */
import { RsaUtill, generateAesKey, aesEncrypt, aesDecrypt, sha256Sign } from './cryptUtil';

const rsaUtill = new RsaUtill();
const AES_KEY = generateAesKey();
const _ = window._;

const judgeEmptyData = data => {
  if (_.isEmpty(data) || !data) {
    return true;
  }
  return false;
};

// 接口加密
export const encrypt = config => {
  const { data, crypt = true, method } = config;
  let encryptoData = data;

  if (crypt && method.toLowerCase() === 'post') {
    const RSA_K = rsaUtill.encrypt(AES_KEY);
    const AES_DATA = judgeEmptyData(data) ? '' : btoa(aesEncrypt(JSON.stringify(data), AES_KEY));
    const timeStamp = new Date().getTime();
    const SIGN = sha256Sign(AES_KEY + timeStamp + AES_DATA);
    console.log('AES_KEY', AES_KEY);
    console.log('timeStamp', timeStamp);
    console.log('AES_DATA', AES_DATA);

    encryptoData = `${RSA_K}|${AES_DATA}|${SIGN}|${timeStamp}`;
  }

  return {
    ...config,
    data: encryptoData,
  };
};

// 接口解密
export const decrypt = response => {
  const {
    data,
    config: { method, crypt = true },
  } = response;
  let decryptoData = data;
  if (crypt) {
    decryptoData = method.toLowerCase() === 'get' ? data : aesDecrypt(data, AES_KEY);
  }

  try {
    return JSON.parse(decryptoData);
  } catch (_) {
    return decryptoData;
  }
};
